export enum ArenaPosition {
    Bottom = 1,
    Top = 2,
    Left = 3,
    Right = 4
}